/**
 * @file forum
 * @author wangzhuang
 */

import {GET_CMSAPI_INDEXDATA, GET_CMSAPI_PUBLISH} from '../actions/ActionTypes';

export function cmsapiIndexData(state = {}, action) {
    switch (action.type) {
        case GET_CMSAPI_INDEXDATA:
            if (action.data.is_error === 0) {
                state = action.data;
                return state;
            }
            return {};
        default:
            return state;
    }
}

export function cmsapiPublish(state = {}, action) {
    switch (action.type) {
        case GET_CMSAPI_PUBLISH:
        case GET_CMSAPI_INDEXDATA:
            if (action.data.is_error === 0) {
                if (action.isMore) {
                    action.data.itemlist.article_list.datalist.unshift(...state.datalist);
                    return state = action.data.itemlist.article_list;
                } else {
                    return state = action.data.itemlist.article_list;
                }
            }
            return {};
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/reducers/forum.js